import { useLocation } from 'react-router-dom';
import useVisitorPresence from '../hooks/useVisitorPresence';

const VisitorPresenceTracker = () => {
  const location = useLocation();
  useVisitorPresence(location.pathname);
  return null;
};

export default VisitorPresenceTracker;
